import * as types from './actionTypes';

const initialState = {
  claims: [],
  claimApprovals: [],
  viewClaimList:[],
  loading: false,
  error: null,
  success: false,
};

const claimReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CLAIMS_REQUEST:
    case types.SAVE_CLAIM_REQUEST:
    case types.CHANGE_CLAIM_STATUS_REQUEST:
    case types.FETCH_CLAIM_APPROVALS_REQUEST:
    case types.SAVE_CLAIM_APPROVAL_REQUEST:
    case types.CHANGE_CLAIM_APPROVAL_STATUS_REQUEST:
    case types.SEND_CLAIM_APPROVAL_REQUEST:
      return { ...state, loading: true, error: null, success: false };

    case types.FETCH_CLAIMS_SUCCESS:
      return { ...state, loading: false, claims: Array.isArray(action.payload) ? action.payload : [], success: false };

    case types.FETCH_CLAIM_APPROVALS_SUCCESS:
      return { ...state, loading: false, claimApprovals: action.payload, success: false };

    case types.SAVE_CLAIM_SUCCESS:
    case types.CHANGE_CLAIM_STATUS_SUCCESS:
    case types.SAVE_CLAIM_APPROVAL_SUCCESS:
    case types.CHANGE_CLAIM_APPROVAL_STATUS_SUCCESS:
    case types.SEND_CLAIM_APPROVAL_SUCCESS:
      return { ...state, loading: false, success: true };

    case types.FETCH_CLAIMS_FAILURE:
    case types.SAVE_CLAIM_FAILURE:
    case types.CHANGE_CLAIM_STATUS_FAILURE:
    case types.FETCH_CLAIM_APPROVALS_FAILURE:
    case types.SAVE_CLAIM_APPROVAL_FAILURE:
    case types.CHANGE_CLAIM_APPROVAL_STATUS_FAILURE:
    case types.SEND_CLAIM_APPROVAL_FAILURE:
      return { ...state, loading: false, error: action.payload, success: false };
    case types.FETCH_VIEW_CLAIM_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case types.FETCH_VIEW_CLAIM_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        viewClaimList: action.payload,
        success: false
      };
    case types.FETCH_VIEW_CLAIM_LIST_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
        success: false
      };
    default:
      return state;
  }
};

export default claimReducer;
